import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, shareReplay, publish, refCount, tap } from 'rxjs/operators';
import { RecipeSearchResult } from '../models/recipe-search-result.model';
import { Settings } from '../models/Settings';
import { FoodPortalStateService } from './food-portal-state.service';
import { Allergen } from '../models/allergen-values.model';

@Injectable({
  providedIn: 'root',
})
export class FoodPortalService {

  allergenListV2 = new Array<Allergen>();
  selectedAllergens = new Array<Allergen>();

  constructor(private $http: HttpClient, private state: FoodPortalStateService) {

    this.allergenListV2.push(new Allergen('celery', 'Celery', 'Ce', 1, true));
    this.allergenListV2.push(new Allergen('crustaceans', 'Crustaceans', 'Cr', 2, true));
    this.allergenListV2.push(new Allergen('eggs', 'Eggs', 'Eg', 3, true));
    this.allergenListV2.push(new Allergen('fish', 'Fish', 'Fi', 4, true));
    this.allergenListV2.push(new Allergen('lupin', 'Lupin', 'Lu', 5, true));
    this.allergenListV2.push(new Allergen('milk', 'Milk', 'Mi', 6, true));
    this.allergenListV2.push(new Allergen('molluscs', 'Molluscs', 'Mo', 7, true));
    this.allergenListV2.push(new Allergen('mustard', 'Mustard', 'Mu', 8, true));
    this.allergenListV2.push(new Allergen('peanuts', 'Peanuts', 'Pe', 9, true));
    this.allergenListV2.push(new Allergen('sesameSeeds', 'Sesame seeds', 'Se', 10, true));
    this.allergenListV2.push(new Allergen('soybeans', 'Soybeans', 'So', 11, true));
    this.allergenListV2.push(new Allergen('sulphurDioxide', 'Sulphur dioxide', 'Su', 12, true));
    this.allergenListV2.push(new Allergen('nuts', 'Nuts', 'Nu', 13, true));
    this.allergenListV2.push(new Allergen('almonds', 'Almonds', 'Al', 14, false, 'nuts'));
    this.allergenListV2.push(new Allergen('brazils', 'Brazil nuts', 'Br', 15, false, 'nuts'));
    this.allergenListV2.push(new Allergen('cashews', 'Cashews', 'Ca', 16, false, 'nuts'));
    this.allergenListV2.push(new Allergen('hazelnuts', 'Hazelnuts', 'Ha', 17, false, 'nuts'));
    this.allergenListV2.push(new Allergen('macadamias', 'Macadamias', 'Ma', 18, false, 'nuts'));
    this.allergenListV2.push(new Allergen('pecans', 'Pecans', 'Pc', 19, false, 'nuts'));
    this.allergenListV2.push(new Allergen('pistachios', 'Pistachios', 'Pi', 10, false, 'nuts'));
    this.allergenListV2.push(new Allergen('walnuts', 'Walnuts', 'Wa', 21, false, 'nuts'));
    this.allergenListV2.push(new Allergen('gluten', 'Gluten', 'Gl', 22, true));
    this.allergenListV2.push(new Allergen('barley', 'Barley', 'Ba', 23, false, 'gluten'));
    this.allergenListV2.push(new Allergen('oats', 'Oats', 'Oa', 24, false, 'gluten'));
    this.allergenListV2.push(new Allergen('rye', 'Rye', 'Ry', 25, false, 'gluten'));
    this.allergenListV2.push(new Allergen('wheat', 'Wheat', 'Wh', 26, false, 'gluten'));

  }

  // the interceptor handles the param value
  getPortalSettings() {
    return this.$http.post<Settings>("GetPortalSettings", null)
      .pipe(
        map(x => new Settings(x)),
        tap(x => {
          this.state.portalSettings = x;
          const defaultProfile = x.referenceIntakeProfiles.find(x => x.isDefault) || x.referenceIntakeProfiles[0];
          this.state.referenceIntakeProfile.next(defaultProfile);
        }),
        publish<Settings>(),
        refCount()
      );
  }

  getRecipes() {

    const params = { customerGroupId: this.state.portalSettings.customerGroupId, portalId: this.state.portalSettings.id };
    return this.$http.post<RecipeSearchResult[]>("GetRecipes", params)
      .pipe(
        map(x => x.map(c => new RecipeSearchResult(c))),
        tap(x => {
          this.state.recipes = x;
          this.state.createNavigation();
        }),
        publish<RecipeSearchResult[]>(),
        refCount()
      );
  }
}
